<template>
	<Row class="user-menu-container flex-align-center px-2">
		<AppDropdownMenu
			offset-y
			:nudge-top="404"
			min-width="215"
			:items="avatarMenuItems"
			transition="slide-y-transition"
			content-class="user-menu-content"
		>
			<template #list-title>
				<Col @click.prevent.stop="" class="menu-header-container pl-3">
					<Row @click.prevent.stop="" class="flex-align-center ml-1">
						<AppAvatar class="nav-button-icon" :size="25" />
						<Col class="display-flex flex-column flex-justify-center ml-2">
							<Row>{{ userFullName }}</Row>
							<Row class="font-size-sm subtle-message">{{ user.email }}</Row>
						</Col>
					</Row>
					<WorkspaceSelectionMenuWrapper class="mt-1" />
				</Col>
			</template>
			<template #activator>
				<Row class="flex-align-center width-100 pr-9">
					<AppWorkspaceAvatar class="ml-n2 workspace-avatar" :account="account" :showText="false" :size="26" />
					<AppAvatar class="nav-button-icon ml-n2" :size="26" />
					<Col v-if="!isSidebarCollapsed" class="display-flex flex-column pl-3 pr-9 width-100">
						<Row class="user-full-name-text">{{ userFullName }}</Row>
						<Row v-if="accountName" class="user-organization-text">{{ accountName }}</Row>
					</Col>
				</Row>
			</template>
		</AppDropdownMenu>
	</Row>
</template>

<script>
import { mapGetters } from 'vuex';
import { capitalizeWord } from '@/utils/language-service';
import AppWorkspaceAvatar from '@/components/WorkspaceSelectionMenu/AppWorkspaceAvatar.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import WorkspaceSelectionMenuWrapper from '@/components/WorkspaceSelectionMenu/WorkspaceSelectionMenuWrapper.vue';
export default {
	name: 'UserMenu',
	components: { WorkspaceSelectionMenuWrapper, AppWorkspaceAvatar },
	props: { isSidebarCollapsed: { type: Boolean } },
	computed: {
		...mapGetters(['user']),
		...mapGetters('account', ['account']),
		accountName() {
			return this.account?.name;
		},
		userFullName() {
			return capitalizeWord(this.user.first_name) + ' ' + capitalizeWord(this.user.last_name);
		},
		avatarMenuItems() {
			return [
				{ divider: true },
				{ text: `My account`, onClick: () => this.openSettingsDialog('SettingsMe') },
				{ text: `Workspace settings`, onClick: () => this.openSettingsDialog('SettingsOrganization') },
				{ divider: true },
				{ text: `Help docs`, onClick: () => this.openInNewTab('https://docs.ply.io/') },
				{ text: `Status page`, onClick: () => this.openInNewTab('https://status.ply.io/') },
				{ text: `Terms`, onClick: () => this.openInNewTab('https://go.ply.io/Terms') },
				{ divider: true },
				{ text: `Log out`, onClick: this.logout },
			];
		},
	},
	methods: {
		openSettingsDialog(routeName) {
			AppDialogManagerService.openSettingsDialog({ routeName });
		},
		logout() {
			this.$router.push({ name: 'logout' });
		},
		openInNewTab(url) {
			window.open(url, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.menu-header-container {
	font-size: 14px;
	font-weight: 400;
	color: var(--primary-font-color);
}

.user-menu-container {
	border-top: 1px solid #dfdfe2;
	height: 50px;
}

.user-menu-content {
	padding-top: 7px;
	padding-bottom: 7px;
	background-color: var(--bg-color);
}

.user-full-name-text {
	font-size: 14px;
	text-align: left;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}

.user-organization-text {
	color: #8f95ab;
	font-size: 11px;
	text-align: left;
	letter-spacing: 0px;
}
.workspace-avatar {
	z-index: 2;
}
</style>
